import React from 'react'

import { Flex, BoxHeadline } from 'shared/ui'

const NoResults = ({ className }) => (
  <Flex
    alignItems="center"
    className={className}
    justifyContent="center"
    mb={6}
    ml={3}
    mr={3}
    mt={6}
  >
    <BoxHeadline>No results found</BoxHeadline>
  </Flex>
)

export default NoResults
